import React, { useId } from "react";
import CustomCheckbox from "view/components/CheckBox";

interface MemberVisibilitySettingProps {
  visible: boolean;
  onChange: (visible: boolean) => void;
}

const MemberVisibilitySetting = ({
  visible,
  onChange,
}: MemberVisibilitySettingProps) => {
  const descriptionId = useId();

  return (
    <div className="w-full mb-4">
      <CustomCheckbox
        name="membersVisibility"
        checked={!visible}
        onChange={(event) => onChange(!event.target.checked)}
        inputProps={{ "aria-describedby": descriptionId }}
        label="Hide member names from observers"
        labelClassName="text-secondaryMid dark:text-textMain"
        labelPlacement="end"
      />
      <p
        id={descriptionId}
        className="pl-8 text-xs text-textMidLight dark:text-textMain"
      >
        Observers in the app will not see who else is in the program. Admins
        will still see all member details.
      </p>
    </div>
  );
};

export default MemberVisibilitySetting;
